import { useTranslation } from 'react-i18next';

import type { Client } from '~/api/clients/types';

import { Icon, Tooltip } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';

import { clientVatCellStyle } from './clientCell.css';

type Props = {
  client: Client;
  value: string | undefined;
};

export const ClientVatCell = ({ client, value }: Props) => {
  const { t } = useTranslation(['clients']);

  return (
    <div className={clientVatCellStyle}>
      {client.peppolId !== null ? (
        <Tooltip content={t('clients:overview.vat.peppolTooltip')}>
          <Icon name="Peppol" size={20} />
        </Tooltip>
      ) : (
        client.clientType === 'organisation' && (
          <Tooltip content={t('clients:overview.vat.mailTooltip')}>
            <Icon name="Mail" size={20} />
          </Tooltip>
        )
      )}
      <span className={desktopTruncateStyle}>{value || '–'}</span>
    </div>
  );
};
